import { GET_PUESTOS_TRABAJO } from "../actions/afiliaciones";
import { GET_ACTIVIDADES_EMPLEADOR } from "../actions/obra";


const INITIAL_STATE = {
  puestosTrabajo: {
    loading: false,
    error: false,
    data: [],
  },
  actividadesEmpleador: {
    loading: false,
    error: false,
    data: [],
  }
}


const afiliaciones = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GET_PUESTOS_TRABAJO}_PENDING`:
      return {
        ...state,
        puestosTrabajo: {
          ...state.puestosTrabajo,
          error: false,
          loading: true,
        },
      };
    case `${GET_PUESTOS_TRABAJO}_REJECTED`:
      return {
        ...state,
        puestosTrabajo: {
          ...state.puestosTrabajo,
          error: true,
          loading: false,
        },
      };
    case `${GET_PUESTOS_TRABAJO}_FULFILLED`:
      return {
        ...state,
        puestosTrabajo: {
          ...state.puestosTrabajo,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_ACTIVIDADES_EMPLEADOR}_PENDING`:
      return {
        ...state,
        actividadesEmpleador: {
          ...state.actividadesEmpleador,
          error: false,
          loading: true,
        },
      };
    case `${GET_ACTIVIDADES_EMPLEADOR}_REJECTED`:
      return {
        ...state,
        actividadesEmpleador: {
          ...state.actividadesEmpleador,
          error: true,
          loading: false,
        },
      };
    case `${GET_ACTIVIDADES_EMPLEADOR}_FULFILLED`:
      return {
        ...state,
        actividadesEmpleador: {
          ...state.actividadesEmpleador,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    default:
      return state;
  }
};


export default afiliaciones;